<template>
  <div class="kiw-form">
    <KIWWebform :defaults="defaults" :cmpLibrary="cmpLibrary" id="kiw_form" />
  </div>
</template>

<script src="./KIWForm.js"></script>
